/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CarrierTariff } from '../models/CarrierTariff';
import type { ExportFormat } from '../models/ExportFormat';
import type { SortDirection } from '../models/SortDirection';
import type { TruckStopCreateCaseRequest } from '../models/TruckStopCreateCaseRequest';
import type { TruckStopCreateCaseResponse } from '../models/TruckStopCreateCaseResponse';
import type { TruckStopGetAvVehiclesResponse } from '../models/TruckStopGetAvVehiclesResponse';
import type { TruckStopGetCertificateVehiclesResponse } from '../models/TruckStopGetCertificateVehiclesResponse';
import type { TruckStopGetCompanyResponse } from '../models/TruckStopGetCompanyResponse';
import type { TruckStopGetInsurancePoliciesResponse } from '../models/TruckStopGetInsurancePoliciesResponse';
import type { TruckStopSearchCasesResponse } from '../models/TruckStopSearchCasesResponse';
import type { TruckStopSearchResponse } from '../models/TruckStopSearchResponse';
import type { TruckStopSearchSortBy } from '../models/TruckStopSearchSortBy';
import type { TruckStopSearchType } from '../models/TruckStopSearchType';
import type { TruckStopUploadResponse } from '../models/TruckStopUploadResponse';
import type { VehicleSortBy } from '../models/VehicleSortBy';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TruckStopService {
  /**
   * Create a new case.
   * @param requestBody
   * @returns TruckStopCreateCaseResponse Created
   * @throws ApiError
   */
  public static createCase(
    requestBody?: TruckStopCreateCaseRequest,
  ): CancelablePromise<TruckStopCreateCaseResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/TruckStop/cases',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Search for cases by various criteria.
   * @param businessEntityId
   * @returns TruckStopSearchCasesResponse OK
   * @throws ApiError
   */
  public static searchCases(
    businessEntityId?: string,
  ): CancelablePromise<TruckStopSearchCasesResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/TruckStop/cases',
      query: {
        'BusinessEntityId': businessEntityId,
      },
    });
  }
  /**
   * Search for companies by various criteria.
   * @param searchType
   * @param searchValue
   * @param limit
   * @param offset
   * @param sortingId
   * @param sortingDesc
   * @param format
   * @returns TruckStopSearchResponse OK
   * @throws ApiError
   */
  public static searchCompanies(
    searchType: TruckStopSearchType,
    searchValue: string,
    limit?: number,
    offset?: number,
    sortingId?: TruckStopSearchSortBy,
    sortingDesc?: boolean,
    format?: ExportFormat,
  ): CancelablePromise<TruckStopSearchResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/TruckStop/companies',
      query: {
        'searchType': searchType,
        'searchValue': searchValue,
        'limit': limit,
        'offset': offset,
        'sortingId': sortingId,
        'sortingDesc': sortingDesc,
        'format': format,
      },
    });
  }
  /**
   * Retrieve a company by its ID.
   * @param companyId
   * @returns TruckStopGetCompanyResponse OK
   * @throws ApiError
   */
  public static getCompany(
    companyId: string,
  ): CancelablePromise<TruckStopGetCompanyResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/TruckStop/companies/{companyId}',
      path: {
        'companyId': companyId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * Get all insurance policies for a company's certificate.
   * @param companyId
   * @returns TruckStopGetInsurancePoliciesResponse OK
   * @throws ApiError
   */
  public static getCompanyCertificateInsurancePolicies(
    companyId: string,
  ): CancelablePromise<TruckStopGetInsurancePoliciesResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/TruckStop/companies/{companyId}/certificate/insurance',
      path: {
        'companyId': companyId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * Get vehicles for a company's certificate.
   * @param companyId
   * @param query
   * @param limit
   * @param offset
   * @param sortBy
   * @param sortDirection
   * @returns TruckStopGetCertificateVehiclesResponse OK
   * @throws ApiError
   */
  public static getCompanyCertificateVehicles(
    companyId: string,
    query?: string,
    limit?: number,
    offset?: number,
    sortBy?: VehicleSortBy,
    sortDirection?: SortDirection,
  ): CancelablePromise<TruckStopGetCertificateVehiclesResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/TruckStop/companies/{companyId}/certificate/vehicles',
      path: {
        'companyId': companyId,
      },
      query: {
        'query': query,
        'limit': limit,
        'offset': offset,
        'sortBy': sortBy,
        'sortDirection': sortDirection,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * Get all vehicles for a company's automated motor vehicle registration.
   * @param companyId
   * @param query
   * @param limit
   * @param offset
   * @param sortBy
   * @param sortDirection
   * @returns TruckStopGetAvVehiclesResponse OK
   * @throws ApiError
   */
  public static getCompanyAutomatedMotorVehicles(
    companyId: string,
    query?: string,
    limit?: number,
    offset?: number,
    sortBy?: VehicleSortBy,
    sortDirection?: SortDirection,
  ): CancelablePromise<TruckStopGetAvVehiclesResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/TruckStop/companies/{companyId}/automated-motor-vehicles',
      path: {
        'companyId': companyId,
      },
      query: {
        'query': query,
        'limit': limit,
        'offset': offset,
        'sortBy': sortBy,
        'sortDirection': sortDirection,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }
  /**
   * Get the standard tariff line items for a company's carrier.
   * Pass format=pdf to receive the tariffs rendered as a PDF instead of JSON.
   * @param companyId
   * @param format
   * @returns CarrierTariff OK
   * @throws ApiError
   */
  public static getCompanyTariffs(
    companyId: string,
    format?: ExportFormat,
  ): CancelablePromise<Array<CarrierTariff>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/TruckStop/companies/{companyId}/tariffs',
      path: {
        'companyId': companyId,
      },
      query: {
        'format': format,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * Stream the uploaded Interstate Tariff document for a company's carrier.
   * @param companyId
   * @returns void
   * @throws ApiError
   */
  public static getCompanyInterstateTariffDocument(
    companyId: string,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/TruckStop/companies/{companyId}/interstate-tariff-document/content',
      path: {
        'companyId': companyId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * Upload a complaint attachment to a temporary location.
   * @param formData
   * @returns TruckStopUploadResponse OK
   * @throws ApiError
   */
  public static uploadComplaintFile(
    formData?: {
      file?: Blob;
    },
  ): CancelablePromise<TruckStopUploadResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/TruckStop/cases/uploads',
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
      },
    });
  }
}
